module.exports = __webpack_public_path__ + "img/dna1_600.27de1fed.jpg";